export interface CartSkuFields {
  sku: string;
  feedSku?: string | null;
  rawSku?: string | null;
  modelKey?: string | null;
  modelCode?: string | null;
}

export function cartSkuForProduct(item: CartSkuFields): string {
  return (
    item.feedSku?.trim() ||
    item.rawSku?.trim() ||
    item.modelKey?.trim() ||
    item.modelCode?.trim() ||
    item.sku
  );
}
